<div class="border-0 px-4 py-1 overflow-auto">
  <div class="company-second-card rounded-lg shadow p-5 border glass-card mt-2">

    <div class="company-first-card mb-4 shadow-lg rounded-lg w-100 px-3 py-2 position-relative probaworkflows-bg">
      <section class="hero-section w-100 px-2 py-1 d-flex justify-content-between align-items-start">
        <div class="hero-content p-1 me-5 col-md-7 col-lg-6">
          <h1 class="hero-title text-white text-x fw-bold">Generated Reports</h1>
          <p class="hero-description mt-1 text-white text-xs">
            Review report history, preview supported files, and download completed outputs from one place.
          </p>
        </div>
      </section>
      <div class="d-flex gap-2 justify-content-md-end mt-5">
        <button class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" type="button" @click="go_to_generate_reports">
          Build New Report
        </button>
        <button class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" type="button" @click="go_to_report_templates">
          View Templates
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <p class="text-x fw-bold mb-1">Generated Files</p>
        <p class="text-muted text-xxs mb-0">Latest report runs for this project.</p>
      </div>
      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" type="button" @click="load_reports(page_number)">
        Refresh
      </button>
    </div>

    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-2 mb-3">
      <div class="d-flex align-items-center gap-2">
        <div v-if="searching_reports" class="d-flex align-items-center gap-1 text-muted text-xxs">
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <span>Searching...</span>
        </div>
      </div>
      <div class="d-flex flex-column flex-sm-row gap-2 align-items-sm-center">
        <input
          v-model.trim="search_query"
          class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
          placeholder="Search generated reports..."
          type="text"
          @input="schedule_search"
        />
      </div>
    </div>

    <div class="row g-3 mb-4">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-4">
        <div class="card shadow-sm border rounded-lg p-3 h-100">
          <p class="text-uppercase text-muted text-xxs mb-1">{{ card.label }}</p>
          <p class="fw-bold text-dark text-xxs mb-1">{{ card.value }}</p>
          <p class="text-muted text-xxs mb-0">{{ card.description }}</p>
        </div>
      </div>
    </div>

    <div class="rounded-lg p-2 overflow-auto">
      <ServerPaginatedTable
        :headers="['ID', 'Report', 'Template', 'Type', 'Format', 'Target', 'Created', 'Status']"
        :data="table_safe_reports"
        :loading="loading_reports"
        :next_page="next_page"
        :page_number="page_number"
        :page_size="page_size"
        :prev_page="prev_page"
        :total_count="total_count"
        :total_pages="total_pages"
        empty_message="No generated reports found."
        loading_text="Loading generated reports..."
        table_id="generated_reports_table"
        @page-change="go_to_page"
      >
        <template #actions="{ row }">
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" type="button" @click="open_preview(row)">
            Preview
          </button>
          <a
            v-if="get_report_by_id(row.id)?.presigned_url"
            :href="get_report_by_id(row.id)?.presigned_url"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            rel="noopener noreferrer"
            target="_blank"
          >
            Download
          </a>
          <span v-else class="text-muted text-xxs">No file</span>
        </template>
      </ServerPaginatedTable>
    </div>
  </div>

  <FilePreviewComponent
    v-if="preview_report"
    :file_name="get_preview_file_name(preview_report)"
    :presigned_url="preview_report.presigned_url"
    @close="close_preview"
  />
</div>
